<div class="page-section">
  <div class="store-performance-dashboard-head">
    <reb-ngx-heading-label color="#15245A" size="h3" weight="500">Store Performance</reb-ngx-heading-label>
  </div>
  <div *ngIf="isStorePerformanceReady" class="page-section-body border noborder-important">
    <reb-ngx-banner *ngIf="isStorePerformanceError" mood="error" message="There was an error when trying to retrieve Store performance."></reb-ngx-banner>
    <div *ngIf="!isStorePerformanceError" class="mat-list mat-list-base custom-mat-list store-performance-wrapper">
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client rn-card-subscription">
        <div card-header-title>
          <reb-ngx-heading-label mood="none" size="h6" weight="500">
            Subscriptions
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label *ngIf="storePerformance.ratePlans !== undefined" mood="default" size="22" weight="700">
            {{storePerformance?.ratePlans}}
          </reb-ngx-label>
          <reb-ngx-label *ngIf="storePerformance?.ratePlans === undefined" mood="default" size="22" weight="700">
            No data
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client rn-card-subscribers">
        <div card-header-title>
          <reb-ngx-heading-label mood="none" size="h6" weight="500">
            Subscribers
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label *ngIf="storePerformance.subscribers !== undefined" mood="default" size="22" weight="700">
            {{storePerformance?.subscribers}}
          </reb-ngx-label>
          <reb-ngx-label *ngIf="storePerformance?.subscribers === undefined" mood="default" size="22" weight="700">
            No data
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client rn-card-customer">
        <div card-header-title>
          <reb-ngx-heading-label mood="none" size="h6" weight="500">
            Customers
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label *ngIf="storePerformance.customers !== undefined" mood="default" size="22" weight="700">
            {{storePerformance?.customers}}
          </reb-ngx-label>
          <reb-ngx-label *ngIf="storePerformance.customers === undefined" mood="default" size="22" weight="700"> No data </reb-ngx-label>
        </div>
      </reb-ngx-card>
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client rn-card-product">
        <div card-header-title>
          <reb-ngx-heading-label mood="none" size="h6" weight="500" >
            Products
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label *ngIf="storePerformance.products !== undefined" mood="default" size="22" weight="700" >
            {{storePerformance?.products}}
          </reb-ngx-label>
          <reb-ngx-label *ngIf="storePerformance.products === undefined" mood="default" size="22" weight="700">
            No data
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client rn-card-rateplan">
        <div card-header-title>
          <reb-ngx-heading-label mood="none" size="h6" weight="500" >
            Rate Plans
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label *ngIf="storePerformance.productRatePlans !== undefined" mood="default" size="22" weight="700">
            {{storePerformance?.productRatePlans}}
          </reb-ngx-label>
          <reb-ngx-label *ngIf="storePerformance.productRatePlans === undefined" mood="default" size="22" weight="700">
            No data
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
    </div>
  </div>
  <!-- skeleton -->
  <div *ngIf="!isStorePerformanceReady" class="page-section-body border noborder-important">
    <div class="mat-list mat-list-base custom-mat-list store-performance-wrapper">
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client">
        <div card-header-title>
          <reb-ngx-heading-label size="h6" weight="500">
            <skeleton-loader [theme]="{'width': '50px'}"></skeleton-loader>
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label size="22" weight="500">
            <skeleton-loader [theme]="{'width': '150px'}"></skeleton-loader>
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client">
        <div card-header-title>
          <reb-ngx-heading-label size="h6" weight="500">
            <skeleton-loader [theme]="{'width': '50px'}"></skeleton-loader>
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label size="22" weight="700">
            <skeleton-loader [theme]="{'width': '150px'}"></skeleton-loader>
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client">
        <div card-header-title>
          <reb-ngx-heading-label size="h6" weight="500">
            <skeleton-loader [theme]="{'width': '50px'}"></skeleton-loader>
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label size="22" weight="700">
            <skeleton-loader [theme]="{'width': '150px'}"></skeleton-loader>
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
      <reb-ngx-card [showHeader]="true" width="size1of1" class="rn-card-client">
        <div card-header-title>
          <reb-ngx-heading-label size="h6" weight="500">
            <skeleton-loader [theme]="{'width': '50px'}"></skeleton-loader>
          </reb-ngx-heading-label>
        </div>
        <div class="card-body-content">
          <reb-ngx-label size="22" weight="700">
            <skeleton-loader [theme]="{'width': '150px'}"></skeleton-loader>
          </reb-ngx-label>
        </div>
      </reb-ngx-card>
    </div>
  </div>
</div>
